import { EventEmitter } from '@angular/core';

export class BroadcastUtil {
  private static emitters: {
    [eventName: string]: EventEmitter<unknown>;
  } = {};

  static get(eventName: string): EventEmitter<unknown> {
    if (!this.emitters[eventName]) {
      this.emitters[eventName] = new EventEmitter<unknown>();
    }
    return this.emitters[eventName];
  }
}
